import React, { createContext, ReactNode, useContext, useState } from 'react';

import { Amelia } from '../components/Layout/components/Amelia/Amelia';
import { Origin } from '../components/Layout/components/Amelia/Amelia.types';

type Context = {
  open: (_origin: Origin, prompt?: string) => void;
};

type Props = {
  children: ReactNode;
};

export const useAmelia = () => useContext(AmeliaContext);

// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-1628661911
export const AmeliaContext = createContext<Context>(undefined as never);

export const AmeliaProvider = ({ children }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prompt, setPrompt] = useState<string | undefined>();
  const [origin, setOrigin] = useState<Origin | undefined>();

  const open = (_origin: Origin, prompt?: string) => {
    setOrigin(_origin);
    setPrompt(prompt);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setPrompt(undefined);
  };

  return (
    <AmeliaContext.Provider value={{ open }}>
      {children}
      {isOpen && origin ? (
        <Amelia prompt={prompt} onClose={close} origin={origin} />
      ) : null}
    </AmeliaContext.Provider>
  );
};
